import PropTypes from "prop-types";
import React from "react";
import { NOOP_UNDEFINED } from "~/constants/callbacks";
import useDropdownOptions, { mapByValue } from "~/hooks/useDropdownOptions";
import Select from "./SelectWrapper/Select";

const createLeadFieldSelect = (
  url,
  { displayName, defaultPlaceholder = "Select...", mapOption = mapByValue } = {},
) => {
  const Component = ({
    id = "",
    name = "",
    value = "",
    placeholder = defaultPlaceholder,
    onChange = NOOP_UNDEFINED,
    isMulti = false,
    isClearable = false,
    addBlank = false,
    ...restProps
  }) => {
    const { options, loading } = useDropdownOptions(url, {
      mapOption,
    });

    return (
      <Select
        validateValue
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable
        isLoading={loading}
        options={options}
        addBlank={addBlank}
        {...restProps}
      />
    );
  };

  Component.displayName = displayName;

  Component.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    isMulti: PropTypes.bool,
    isClearable: PropTypes.bool,
    addBlank: PropTypes.bool,
  };

  return Component;
};

export default createLeadFieldSelect;
